import axios from 'axios';

export default class VaccinationToolYellowFeverHandler {
    constructor({ contextPath }) {
        this.contextPath = contextPath;
    }

    getCountries() {
        return axios
            .get(`${this.contextPath}/api/vaccinations/yellow-fever-countries`)
            .then(response => response.data);
    }
}



// WEBPACK FOOTER //
// ./src/frontend/apps/VaccinationTool/VaccinationToolYellowFeverHandler.js